<template>
  <v-btn  :value="value" :to="route" :class="btnPaddingClass">
    <span>{{ label }}</span>
      <v-icon :color="iconColor">{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
import { getIcon, getIconColor } from '@/js/store'
import { SearchUtils } from '@/js'
export default {
  props: {
    nav: Object
  },
  computed: {
    bigEnough () {
      return this.$vuetify.breakpoint.smAndUp
    },
    btnPaddingClass () {
      return this.bigEnough ? '' :  ' fid-no-sidepad'
    },
    value () {
      return this.nav.value
    },
    label () {
      return SearchUtils.unCamel({ text: this.value })
    },
    route () {
      return '/' + this.value
    },
    icon () {
      return getIcon(this.nav.itemtype)
    },
    iconColor () {
      return getIconColor(this.nav.itemtype)
    }
  },
  name: 'app-bottom'
}
</script>
